<template>
  <div>
    <div class="row">
      <div class="col-lg-2">
        <label>Name</label>
        <input type="text" placeholder="Name" class="form-control" v-model="filters.name" @keydown.enter="projectStore.updateFilters('name', $event.target.value)">
      </div>
      <div class="col-lg-2">
        <label>Status</label>
        <v-select
          :options="statuses" label="label" index="index" placeholder="Status"
          v-model="filters.status" @change="projectStore.updateFilters('status', $event)" multiple="multiple"></v-select>
      </div>
      <div class="col-lg-2">
        <label>Departments</label>
        <v-select
          multiple
          placeholder="Departments"
          label="label" index="index"
          :options="departments"
          v-model="filters.departments"
          @change="projectStore.updateFilters('departments', $event)"
        ></v-select>
      </div>
      <div class="col-lg-2">
        <label>Participants</label>
        <v-select
          multiple
          placeholder="Participants"
          label="username" index="id"
          :options="users"
          v-model="filters.participants"
          @change="projectStore.updateFilters('participants', $event)"
        ></v-select>
      </div>
      <div class="col-lg-2">
        <label>Clients</label>
        <v-select
          label="name" index="id"
          placeholder="Clients"
          :options="f.clients"
          v-model="filters.client"
          @change="projectStore.updateFilters('client', $event)"
        ></v-select>
      </div>
      <div class="col-lg-2">
        <label>Show Active</label>
        <v-select
          label="text" index="index"
          :options="archivedStatus"
          v-model="filters.archived"
          @change="projectStore.updateFilters('archived', $event)"
        ></v-select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import countries from '../../../../../static/countries.json'
import { useTaskStore } from '../../../../stores/TaskStore'
import { useDataStore } from '../../../../stores/DataStore'
import { storeToRefs } from 'pinia'
import { useProjectStore } from '../../../../stores/ProjectStore'

export default {
  setup () {
    const store = useTaskStore()
    const dataStore = useDataStore()
    const projectStore = useProjectStore()
    dataStore.loadDepartments()
    const { departments } = storeToRefs(dataStore)
    const statuses = store.taskStatuses
    const filters = {...projectStore.filters}
    return { store, dataStore, departments, statuses, projectStore, filters }
  },
  data () {
    return {
      archivedStatus: [
        {text: 'Active', index: 1},
        {text: 'Deleted', index: 0},
        {text: 'Show all', index: '0,1'}
      ],
      countries
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      users: 'getUsers'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Filters.vue